package studio.goodegg.capsule

data class User(
    val email: String,
)